import { Box, clickableStyle, getSpacing, Grid, ListContext, PAGE_DEFAULT, PAGE_SIZE_UNLIMITED, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { FilePanel } from "components";
import { FileTypeCategory, Permission, StudentServiceEditResource, StudentServiceFile, StudentServiceListFilter, UploadFile } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { initDataModel } from "utils";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import { ServiceFile } from "./ServiceFile";
import { fileDetailPageRoute } from "pages/students/student-applications/StudentApplicationPage/FileDetail/FileDetailPage";
import { Outlet, useNavigate } from "react-router-dom";
import { useList, useRouter } from "hooks";
import { FileListItem } from "pages/students/student-applications/StudentApplicationPage/FileList/FileListItem";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ServiceFiles = (props: {
  rootPermission: Permission;
  editResource: StudentServiceEditResource;
  id: number;
  serviceFiles: StudentServiceFile[];
  setServiceFiles: (value: StudentServiceFile[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();
  const [files, setFiles] = useState<StudentServiceFile[]>();

  const [listFilter, setListFilter] = useState<StudentServiceListFilter>({
    page: PAGE_DEFAULT,
    pageSize: PAGE_SIZE_UNLIMITED,
  });

  const renderFileItem = (file: StudentServiceFile, fileIndex: number) => {
    const matchedFileCategory = props.editResource?.fileCategories?.find(c => c.id == file.fileCategoryId);

    return (
      <FileListItem file={file} index={fileIndex} fileCategory={matchedFileCategory ? matchedFileCategory.name : undefined} />
    );
  };

  const { tableContainerRef, loadList } = useList({
    listFilter: listFilter,
    setListFilter: setListFilter,
    fetchList: (listFilter) => {
      ApiService.studentServices.getStudentServiceFiles(props.id).then((response) => {
        setFiles(response);
      });
    },
  });

  useEffect(() => {
    if (props.id) {
      ApiService.studentServices.getStudentServiceFiles(props.id).then((response) => {
        setFiles(response);
      });
    }
  }, [props.id]);

  return (
    <>
      <Grid ref={breakpointsRef} container spacing="sm">
        {files?.map((file, fileIndex) => renderFileItem(file, fileIndex))}
        {/* {props.serviceFiles.map((serviceFile, index) => (
          <Grid key={index} item xs={smallFieldBreakpoints}>
            <ServiceFile
              rootPermission={props.rootPermission}
              serviceFile={serviceFile}
              setServiceFile={(serviceFile) =>
                props.setServiceFiles(
                  produce(props.serviceFiles, (draft) => {
                    draft[index] = serviceFile;
                  })
                )
              }
              cancelCreate={() => {
                props.setServiceFiles(
                  produce(props.serviceFiles, (draft) => {
                    draft.splice(index, 1);
                  })
                );
              }}
            />
          </Grid>
        ))} */}

        <Grid item xs={smallFieldBreakpoints}>
          <Box
            position="relative"
            p={getSpacing("sm")}
            overflow="hidden" // need this for ellipsis to work?
            sx={{
              border: (theme) => `1px solid ${theme.palette.border.dark}`,
              pointerEvents: "auto",
              opacity: 1,
            }}
          >
            <Stack
              position="relative"
              direction="row"
              justifyContent={"center"}
              alignItems={"center"}
              sx={{ height: "42px", ...clickableStyle, opacity: "0.7" }}
              onClick={() =>
                navigate({
                  pathname: fileDetailPageRoute.getPath({
                    fileType: FileTypeCategory.StudentServiceFile,
                    screenType: "dialog",
                    crudMode: "edit",
                    parentEntityId: props.id,
                    entityId: 0,
                  }),
                })
              }
            >
              <FileUploadRoundedIcon />
              <Typography>Add File</Typography>
            </Stack>
          </Box>
          {/* <FilePanel
          onFileChange={(fileName, fileSize, uploadingData) => {
            const newServiceFile = initDataModel<StudentServiceFile>({
              uploadFile: initDataModel<UploadFile>({
                fileName: fileName,
                fileSize: fileSize,
                uploadingData: uploadingData,
              }),
            });

            props.setServiceFiles(
              produce(props.serviceFiles, (draft) => {
                draft.push(newServiceFile);
              })
            );
          }}
        /> */}
        </Grid>
      </Grid>

      <ListContext.Provider value={{ loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }) }}>
        {matchTemplatePath(fileDetailPageRoute.templatePath) && <Outlet />}
      </ListContext.Provider>
    </>
  );
};
